import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'amountPipe',
  standalone: true,
})
export class AmountPipe implements PipeTransform {
  private currencyPipe = new CurrencyPipe('kk_KZ');
  transform(value?: number | string): string {
    const convertedValue = Number(value);
    const amount = (convertedValue ?? 0) / 100;
    return this.currencyPipe.transform(amount, 'KZT', 'symbol', '1.0-2') || '0 ₸';
  }
}
